"use client";
import { registerUrl } from "@/constants/api";
import { list } from "@/constants/common";
import { Button, Col, Image, Row } from "antd";
import _ from "lodash";
import styles from "./index.module.scss";
import { Fragment } from "react";
export default function CommonBanner({
  bannerId,
  activeIndex,
}: {
  bannerId: string;
  activeIndex?: string;
}) {
  function clickFn() {
    if (list[bannerId].btnLink) {
      location.href = list[bannerId].btnLink;
    } else {
      location.href = registerUrl;
    }
  }
  const imgPc = _.get(
    list[bannerId],
    ["imgList", `${activeIndex}`],
    list[bannerId].imgUrl
  );
  const imgMoblie = _.get(
    list[bannerId],
    ["imgListMoblie", `${activeIndex}`],
    list[bannerId].imgMobileUrl
  );
  return (
    <div className={styles.bannerWrapper}>
      <div
        className={
          styles.bannerBox + " mediaBanner " + styles[list[bannerId].bgClass]
        }
      >
        <Image
          src={imgPc}
          preview={false}
          wrapperClassName={`pcImg ${list[bannerId].title ? "" : "relative"}`}
        />
        <Image
          src={imgMoblie ? imgMoblie : imgPc}
          preview={false}
          wrapperClassName={`mobileImg ${
            list[bannerId].title ? "" : "relative"
          }`}
        />
        {list[bannerId].mp4Url && (
          <div className={styles.mp4Box + " mp4Box"}>
            <video autoPlay loop muted>
              <source src={list[bannerId].mp4Url} type="video/mp4" />
            </video>
          </div>
        )}
        
        {list[bannerId].title && (
          <div className={styles.box + " box"}>
            {list[bannerId].leftImg && (
          <div className={styles.leftImg + " leftImg"}>
            <Image src={list[bannerId].leftImg} preview={false} />
          </div>
        )}
            <Row align={"middle"} className="bannerGlobal">
              <Col
                span={
                  list[bannerId].rightImg
                    ? 14
                    : _.get(list[bannerId], "contSpan", 24)
                }
              >
                <div className={styles.title + " title "+styles[list[bannerId].fontClass]}>
                  {list[bannerId].topTxt ? (
                    <div
                      className={
                        styles.topTxt +
                        " topTxt " +
                        `${list[bannerId].topTransparent ? "colorTransparent" : ""}`
                      }
                    >
                      {list[bannerId].topTxt}
                    </div>
                  ):list[bannerId].seat&&(
                    <div
                    className={
                      styles.topTxt +
                      " topTxt " +
                      `${list[bannerId].topTransparent ? "colorTransparent" : ""}`
                    }
                    style={{opacity:"0"}}
                  >
                    占位
                  </div>
                  )}
                  {_.isArray(list[bannerId].title) ? (
                    <div className={styles.tit + " tit"}>
                      {list[bannerId].title.map((t: string, i: number) => {
                        return <p key={i}>{t}</p>;
                      })}
                    </div>
                  ) : (
                    <div className={styles.tit + " tit"}>
                      {list[bannerId].title}
                    </div>
                  )}
                  {_.get(list[bannerId], "tipList", []).map(
                    (t: string, i: number) => {
                      return (
                        <div className={styles.tip + " tip "+styles[list[bannerId].titleTip]} key={i}>
                          {t}
                        </div>
                      );
                    }
                  )}
                  {list[bannerId].topTransparent && (
                    <div
                      className={`${styles.topTxt} topTxt ${
                        list[bannerId].topTransparent ? "colorTransparent" : ""
                      }`}
                    >
                      占位
                    </div>
                  )}
                  {list[bannerId].buttonText && (
                    <Button className={styles.btn + " btn"} onClick={clickFn}>
                      {list[bannerId].buttonText}
                      <span> {`>`} </span>
                    </Button>
                  )}
                </div>
              </Col>
              {list[bannerId].rightImg && (
                <Col span={10}>
                  <img
                    src={list[bannerId].rightImg}
                    className={styles.rightImg + " rightImg"}
                    {..._.get(list[bannerId], "rightImgStyle", {})}
                  />
                </Col>
              )}
            </Row>
          </div>
        )}
      </div>
    </div>
  );
}
